import { c as _c } from "react/compiler-runtime";
import useAuth from '@/hooks/useAuth';
import { BRAND_ADMIN_CPA, BRAND_ADMIN_PPU, GU_ADMIN } from '@/utils/enums/userRoles';
const usePermissions = () => {
  const $ = _c(32);
  const {
    user
  } = useAuth();
  let t0;
  if ($[0] !== user?.is_superuser) {
    t0 = () => !!user?.is_superuser;
    $[0] = user?.is_superuser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isSuperuser = t0;
  let t1;
  if ($[2] !== user?.is_giddyup_staff) {
    t1 = () => !!user?.is_giddyup_staff;
    $[2] = user?.is_giddyup_staff;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isGiddyUpStaff = t1;
  let t2;
  if ($[4] !== isSuperuser || $[5] !== user?.roles) {
    t2 = role => isSuperuser() || !!user?.roles?.find(r => r === role);
    $[4] = isSuperuser;
    $[5] = user?.roles;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const hasRole = t2;
  let t3;
  if ($[7] !== user?.roles) {
    t3 = () => !!user?.roles?.find(_temp);
    $[7] = user?.roles;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const isBrandAdmin = t3;
  let t4;
  if ($[9] !== hasRole) {
    t4 = () => hasRole(GU_ADMIN);
    $[9] = hasRole;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const isGuAdmin = t4;
  let t5;
  if ($[11] !== isSuperuser || $[12] !== user) {
    t5 = property => isSuperuser() || !!user?.[property];
    $[11] = isSuperuser;
    $[12] = user;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const hasProperty = t5;
  let t6;
  if ($[14] !== isSuperuser || $[15] !== user?.all_permissions) {
    t6 = requiredPermissions => {
      if (!Array.isArray(requiredPermissions)) {
        requiredPermissions = [requiredPermissions];
      }
      return isSuperuser() || requiredPermissions.every(permission => !!user?.all_permissions.find(p => p.codename_full === permission));
    };
    $[14] = isSuperuser;
    $[15] = user?.all_permissions;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const hasPermission = t6;
  let t7;
  if ($[17] !== isSuperuser || $[18] !== user?.all_permissions) {
    t7 = t8 => {
      let requiredPermissions_0 = t8 === undefined ? [] : t8;
      if (!Array.isArray(requiredPermissions_0)) {
        requiredPermissions_0 = [requiredPermissions_0];
      }
      return isSuperuser() || !requiredPermissions_0.length || requiredPermissions_0.some(permission_0 => !!user?.all_permissions.find(p_0 => p_0.codename_full === permission_0));
    };
    $[17] = isSuperuser;
    $[18] = user?.all_permissions;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const hasSomePermission = t7;
  let t8;
  if ($[20] !== user?.all_permissions) {
    t8 = requiredPermissions_1 => {
      if (!Array.isArray(requiredPermissions_1)) {
        requiredPermissions_1 = [requiredPermissions_1];
      }
      return requiredPermissions_1.every(permission_1 => !!user?.all_permissions.find(p_1 => p_1.codename_full === permission_1));
    };
    $[20] = user?.all_permissions;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const hasExactPermission = t8;
  let t9;
  if ($[22] !== hasExactPermission || $[23] !== hasPermission || $[24] !== hasProperty || $[25] !== hasRole || $[26] !== hasSomePermission || $[27] !== isBrandAdmin || $[28] !== isGiddyUpStaff || $[29] !== isGuAdmin || $[30] !== isSuperuser) {
    t9 = {
      isSuperuser,
      isGiddyUpStaff,
      isBrandAdmin,
      isGuAdmin,
      hasRole,
      hasProperty,
      hasPermission,
      hasSomePermission,
      hasExactPermission
    };
    $[22] = hasExactPermission;
    $[23] = hasPermission;
    $[24] = hasProperty;
    $[25] = hasRole;
    $[26] = hasSomePermission;
    $[27] = isBrandAdmin;
    $[28] = isGiddyUpStaff;
    $[29] = isGuAdmin;
    $[30] = isSuperuser;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};
export default usePermissions;
function _temp(r_0) {
  return [BRAND_ADMIN_PPU, BRAND_ADMIN_CPA].includes(r_0);
}